<template>
    <div class="papsi-wrapper">
        <div class="papsi-wrapper flex justify-between ">
            <div class="">
                <h1 class="text-2xl font-semibold text-[#24723b]">Employee 201</h1>
                <p class="text-xs text-[#747474] mt-2">Home / Personnel Services /  Employee 201 Attachments</p>
            </div>
            <div>
                <button class="bg-[#016B00] py-3 px-5 rounded-md text-sm mr-5 w-[250px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444] text-[#fff]" v-on:click="HideView">+ Upload PDF Attachments</button>
            </div>
        </div>

    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        
        <div v-if="TableView">
            <div class="grid grid-cols-11 w-full gap-3 mb-5">
                <input type="text"  @input="isTyping = true" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
                <!-- <select class="col-span-1 border-[#b7b8b7] border  rounded-md   outline-none  text-[#535353] text-center text-sm" v-model="sort" >
                    <option value="Asc">Asc</option>
                    <option value="Desc">Desc</option>
                </select> -->
            </div>
            <div class=" bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" @DeleteButton="DeleteButton" :VButton="true" :tablename="tablename" :column="column" :header="header" :info="info" :DButton="true" :EButton="false" @ViewButton="ViewButton" />
            </div>
        </div>
    </div>
    <div v-if="UploadPDf">
        <div @click="AddJobdescription = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#12760A] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-semibold">Upload PDF Attachments</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">EMPLOYEE NAME</p> 
                    <SelectionControl @getEmpKey="getEmpKey" :suggestions="$store.state.emp_info"/>
                    <!-- <select v-model="empID" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none">
                        <option selected disabled value="">Select Employee name</option>
                        <option v-for="(name , index) in GetName" :key="index" :value="name.employee_key"  class="text-sm">{{ name.full_name }}</option>
                    </select> -->
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Title</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="EG:CONSIDERATION FORM" v-model="title">
                    
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Remarks</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="Remarks" v-model="remarks">

                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Upload PDF Attachments</p>
                    <input type="file"  @change="onFileChange" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#bbbbbb]  w-full outline-none">
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t font-medium">
                <button class="text-sm text-white bg-[#12760A] py-1.5 px-7 rounded-md w-[100px] text-center" @click="Add201file">Add</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="UploadPDf = false">Cancel</button>
            </div> 
            </div>
            </div>
    </div>
    <Loading v-if="false"/>
    <Modal @outside="outsidemodal" @confirmation="test" v-show="modal"/>

    <div v-if="Validation">
        <Prompt @CloseSignatory="Validation = false" type="VALIDATION"/>
    </div>

    <div v-if="Add201">
        <Prompt @CloseSignatory="Add201 = false" type="ADD201"/>
    </div>
    
    <div v-if="Del201">
        <Prompt @CloseSignatory="Del201 = false" type="DELETE"/>
    </div>
  
  
    
</template> 

<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import SelectionControl from '../../../components/selection/SelectionControl.vue'
import TableControl from '../../controls/TableControl/TableControl.vue'
import Loading from '../../controls/Loading/LoadingControl.vue'
import Modal from '../../controls/modal/ModalSample.vue'
import Services from '../../../services/admin'
import Prompt from '../../controls/Prompt/RequestPromt.vue'
export default defineComponent({
    components:{
        TableControl,
        Modal,
        Loading,
        Prompt,
        SelectionControl
    },
    data(){
        return{
            isTyping:       false,
            search:         '',
            Del201:         false,
            Add201:         false,
            Validation:     false,
            modal:          false,
            TableView:      true,
            UploadPDf:      false,
            GetName:        '',
            empID:          '',
            file:           '',
            title:          '',
            info:           '',
            source:         '',
            column:[
                'index',
                'fullname',
                'title',
                'remarks'
            ],
            header:[
            {
                id: 1,
                label: 'NoofItems',
                title: 'No',
                visible: true
            },
            {
                id: 2,
                label: 'Employee ID',
                title: 'Employee Name',
                visible: true
            },
            {
                id: 4,
                label: 'Title',
                title: 'Title',
                visible: true
            },
            {
                id: 5,
                label: 'Remarks',
                title: 'Remarks',
                visible: true
            },
            {
                id: 5,
                label: 'Action',
                title: 'Action',
                visible: true
            }]
        }
    },
    watch: {
                search: _.debounce(function() {
                this.isTyping = false;
                }, 600),
                isTyping: function(value) {
                if (!value) {
                    this.getEmp201()
                }
                }
    },
    mounted(){
        this.getName()
        this.Getall201Employee()
    },
    methods: {
        async getEmp201(){
            try{
                const success = await Services.get201Files(this.search);
                this.info     = success.data
            }
            catch(error){
                console.log(error)
            }
                
        },
        getEmpKey(key){
            this.empID = key
        },
        receiveEmit() {
            this.modal = true
        },
        onFileChange(e){
            this.file = e.target.files[0];
        },
        test(){
            this.modal = false  
        },
        outsidemodal(){
            this.modal = false  
        },
        HideView(){
            if (!this.TableView){
                this.UploadPDf = false
                this.ViewTable = '+ Assign Job Description'
            }
            else{
                this.UploadPDf = true
                this.ViewTable = 'View Table'
            }
        },
        async Add201file(){
            this.$emit("showLoader")

            if(!this.title || !this.remarks || !this.file || !this.empID){
                this.Validation = true
                this.$emit("hideLoader")
                return
            }

            await Services.addEmployee201(this.title,this.remarks,this.file,this.empID);
            this.UploadPDf = false
            this.Getall201Employee()
            this.$emit("hideLoader")
            this.title      = ''
            this.remarks    = ''
            this.file       = ''
            this.empID      = ''
            this.Add201 = true

        },
        async getName(){
            const success = await Services.getEmployeeName();
            this.GetName = success.data
        },
        async Getall201Employee(){
            this.$emit("showLoader")
            const success = await Services.get201Files(this.search);
            this.info = success.data
            this.test()
            this.$emit("hideLoader")
        },
        async ViewButton(row){
            try {
                this.$emit("showLoader")
                const success = await Services.get201FilesbyID(row.key);
                this.source = success.data.source
                this.viewFile();
                this.$emit("hideLoader")
            } catch (error) {
                console.error("Error:", error);
            }
        },
        viewFile(){
            if (!this.source) {
                alert("No source data available.")
                console.error("No source data available.");
                return;
            }

            let pdfWindow = window.open("","_blank");
            setTimeout(() => {
                pdfWindow.document.write(
                    "<iframe allowfullscreen='true' width='100%' height='100%' style='margin:0 0 0 0; padding:0 0 0 0; border: none; outline: none; position: fixed; top:0;right:0' src='data:application/pdf;base64, " +
                    encodeURI(this.source) + "'></iframe>");}, 1000);
        },
        async DeleteButton(row){
            this.$emit("showLoader")
            await Services.delete201FilesbyID(row.key);
            this.Getall201Employee()
            this.$emit("hideLoader")
            this.Del201 = true
        }
        },
})
</script>



